module.exports = __webpack_public_path__ + "files/ffe44a1e121e8dd788c9d60d00a50990.png";